/* eslint-disable no-undef */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/commonService";

const initialState = {
    data:[],
    jobcards:[],
    sizeMaster:[],
    departmentMaster:[],
    machineMaster:[],
    customerMaster:[],
    userMaster:[],
    planTypeMaster:[],
};

export const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
       
    },
    extraReducers: (builder) =>{
        builder
        .addCase(getConstantVariable.fulfilled, (state,action)=>{
            state.data = action.payload;
        })
        .addCase(getAllJobcards.fulfilled, (state,action)=>{
            state.jobcards = action.payload;
        })
        .addCase(getAllSizeMasterDropdown.fulfilled, (state,action)=>{
            state.sizeMaster = action.payload;
        })
        .addCase(getAllDepartmentMasterDropdown.fulfilled, (state,action)=>{
            state.departmentMaster = action.payload;
        })
        .addCase(getAllMachineMasterDropdown.fulfilled, (state,action)=>{
            state.machineMaster = action.payload;
        })
        .addCase(getAllCustomerMasterDropdown.fulfilled, (state,action)=>{
            state.customerMaster = action.payload;
        })
        .addCase(getPlanTypeList.fulfilled, (state,action)=>{
            state.planTypeMaster = action.payload;
        })
        .addCase(getAllUserMasterDropdown.fulfilled, (state,action)=>{
            state.userMaster = action.payload;
        })
    }
  });

// export const { addCategorySelectedData } = commonSlice.actions;
export default commonSlice.reducer;

export const getConstantVariable = createAsyncThunk('getConstantVariable', async () =>{
    console.log(">> loaded getConstantVariable");
    const res = await ItemService.getConstantVariable();
    return res.data;
})

export const getAllJobcards = createAsyncThunk('getAllJobcards', async (param) =>{
    // console.log(">> loaded getAllJobcards");
    const res = await ItemService.getAllJobcards({});
    return res.data;
})

export const getAllSizeMasterDropdown = createAsyncThunk('getAllSizeMasterDropdown', async (param) =>{
    // console.log(">> loaded getAllSizeMasterDropdown");
    const res = await ItemService.allCommonServices({},'getAllSizeMasterDropdown');
    return res.data;
})

export const getAllDepartmentMasterDropdown = createAsyncThunk('getAllDepartmentMasterDropdown', async (param) =>{
    // console.log(">> loaded getAllDepartmentMasterDropdown");
    const res = await ItemService.allCommonServices({},'getAllDepartmentMasterDropdown');
    return res.data;
})

export const getAllMachineMasterDropdown = createAsyncThunk('getAllMachineMasterDropdown', async (param) =>{
    // console.log(">> loaded getAllMachineMasterDropdown");
    const res = await ItemService.allCommonServices({},'getAllMachineMasterDropdown');
    return res.data;
})

export const getAllCustomerMasterDropdown = createAsyncThunk('getAllCustomerMasterDropdown', async (param) =>{
    // console.log(">> loaded getAllCustomerMasterDropdown");
    const res = await ItemService.allCommonServices({},'getAllCustomerMasterDropdown');
    return res.data;
})

export const getPlanTypeList = createAsyncThunk('getPlanTypeList', async (param) =>{
    // console.log(">> loaded getPlanTypeList");
    const res = await ItemService.allCommonServices({},'getPlanTypeList');
    return res.data;
})

export const getAllUserMasterDropdown = createAsyncThunk('getAllUserMasterDropdown', async (param) =>{
    // console.log(">> loaded getAllUserMasterDropdown");
    const res = await ItemService.allCommonServices({},'getAllUserMasterDropdown');
    return res.data;
})
